import type {
	ProductEntity,
	ProductsQueryItemModel,
} from '@/entities/assortment'
import type { SRT_RowSelectionState } from '@/shared/components/master-table'
import type { OnChangeFn } from '@tanstack/react-table'
import type { StateCreator } from 'zustand'

export type TableSliceShape = {
	isSidebarOpen: boolean
	sidebarContent: ProductEntity | ProductsQueryItemModel | null
	setSidebarContent: (
		sidebarContent: ProductEntity | ProductsQueryItemModel | null
	) => void
	setIsSidebarOpen: (isSidebarOpen: boolean) => void
	isAllProductsSelected: boolean
	setIsAllProductsSelected: (isAllProductsSelected: boolean) => void
	localData: Record<string, Record<string, any>>
	setLocalData(items: Record<string, object>): void
	rowSelection: SRT_RowSelectionState
	setRowSelection: OnChangeFn<SRT_RowSelectionState>
	reset(): void
}

export const createLayoutSlice: StateCreator<TableSliceShape> = (set) => ({
	isSidebarOpen: false,
	sidebarContent: null,
	isAllProductsSelected: false,
	localData: {},
	rowSelection: {},
	setIsSidebarOpen: (isSidebarOpen: boolean) =>
		set((state) => ({ ...state, isSidebarOpen })),
	setSidebarContent: (
		sidebarContent: ProductEntity | ProductsQueryItemModel | null
	) => set((state) => ({ ...state, sidebarContent })),
	setIsAllProductsSelected: (isAllProductsSelected: boolean) =>
		set((state) => ({ ...state, isAllProductsSelected })),
	setLocalData: (localData) => set((state) => ({ ...state, localData }), true),
	setRowSelection: (updaterOrValue) =>
		set((state) => ({
			...state,
			rowSelection:
				typeof updaterOrValue === 'function'
					? updaterOrValue(state.rowSelection)
					: updaterOrValue,
		})),
	reset: () =>
		set((state) => ({
			...state,
			localData: {},
			rowSelection: {},
		})),
})
